<template>
    <page :loading="loading">
        <div slot="header" class="flex-row">
			<div class="flex-item page_header">
				<el-form size="small" :inline="true">
					<el-form-item>
						<el-button @click="table.form = {sort: 0, is_show: 1},showDialog = true" type="primary" plain>添加菜单</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

        <page-table rowkey="id" :treeprops="{ children: 'children', hasChildren: 'hasChildren' }" :datas="table.data" :page="table.search.page" :size="table.search.size" :total="table.count" @change="LoadDatas">
			<el-table-column prop='name'                           label='菜单名称'  header-align="left" align='left'/>
			<el-table-column label="图标" align="center" width="200">
				<template slot-scope="scope">
					<i :class="scope.row.icon" style="font-size: 20px;"></i>
				</template>
			</el-table-column>
			<el-table-column prop='sort'                           label='排序' align='center' width="200"/>
			<el-table-column prop='component'                      label='菜单地址' align='center'/>
			<el-table-column label="状态" align="center" width="260">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.is_show">显示</el-tag>
					<el-tag v-else type="danger">隐藏</el-tag>
				</template>
			</el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="120">
                <template slot-scope="scope">
					<el-button @click="table.form = scope.row, showDialog = true" type="text" size="small">修改</el-button>
                    <el-button v-if=" scope.row.pid == 0" @click="table.form = {sort: 0, is_show: 1, pid: scope.row.id}, scope.row,showDialog = true" type="text" size="small">新增</el-button>
                    <el-button @click="ActionDel(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </page-table>

        <el-dialog :modal="false" title="系统菜单" :visible.sync="showDialog" width="35%">
			<el-form label-width="100px">
				<el-form-item label="上级菜单">
				    <el-select v-model="table.form.pid" placeholder="请选择上级菜单" clearable :disabled="table.form.id && !table.form.pid ? true : false">
						<el-option label="请选择" :value="0"></el-option>
						<el-option v-for="(item,index) in mainMenuList" :key="index" :label="item.name" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="菜单名称">
					<el-input v-model="table.form.name" placeholder="请输入菜单名称"></el-input>
				</el-form-item>
				<el-form-item label="菜单图标" v-if="!table.form.pid">
					<el-input v-model="table.form.icon" placeholder="请选择菜单图标">
						<el-button @click="showIconDialog = true" slot="append" icon="el-icon-circle-plus-outline"></el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="显示排序">
					<el-input-number :min="0" v-model="table.form.sort" size="mini"></el-input-number>
				</el-form-item>
				<el-form-item label="菜单路径">
					<el-input v-model="table.form.component" placeholder="请输入菜单路径"></el-input>
				</el-form-item>
				<el-form-item label="显示状态">
					<el-switch v-model="table.form.is_show" :active-value="1" :inactive-value="0" active-color="#188fff" inactive-color="#e5e5e5"></el-switch>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="ActionSave(table.form)">保存</el-button>
					<el-button @click="showDialog = false, table.form = {}">取消</el-button>
				</el-form-item>
			</el-form>
        </el-dialog>
		
		<el-dialog title="菜单图标" :visible.sync="showIconDialog" width="30%">
			<div class="icon_list">
				<div @click="chooseIcon(name)" class="icon_item" v-for="(name, index) in iconData" :key="index">
					<i :class="name"></i>
					<div>{{ name }}</div>
				</div>
			</div>
		</el-dialog>
    </page>
</template>
<script>
import iconData from '/src/basic/tools/icon.json';
export default {
    data(){
        return {
			showDialog: false,
			showIconDialog: false,
            loading: false,
            table:{
                data: [],
                form: {},
                search: {
                    _page: 1,
                    _size: 20,
                },
            	_count:0,
            },
			iconData: iconData,
			mainMenuList: [],
        }
    },
    mounted() {
		this.LoadDatas();
		this.selectMainMenu();
    },
    methods: {
		//查询一级菜单栏
		selectMainMenu(){
			this.$get('sys-menu',{pid: 0, _order: 'sort'}).then(res=>{  
				this.mainMenuList = res.data;
			}).catch(err=>{
			    this.$warning(err);
			});
		},
		//选择图标
		chooseIcon(name){
			this.table.form.icon = name;
			this.showIconDialog  = false;
		},
        LoadDatas(){
			this.loading = true;
            this.$get('tree_menu_list').then(res=>
            {   
                this.table.data = res.data, this.loading = false;
            }).catch(err=>
            {
				this.$warning(err), this.loading = false;
            });
        },
        /**
         * 保存
         * @param item 要保存的数据
         * **/
        ActionSave(item){
			if( !item.name ){
				return this.$warning('请输入菜单名称');
			}
			if( !item.pid && !item.icon ){
				return this.$warning('请选择菜单图标');
			}
			if( item.pid && !item.component ){
				return this.$warning('请输入菜单路径');
			}
			
            this.loading = true;
            this.$save('sys-menu',item).then(res=>
            {
				this.selectMainMenu();
                this.loading = false, this.LoadDatas(), this.$success('操作成功'), this.showDialog = false;
            }).catch(err=>
            {
                this.loading = false, this.$warning(err);
            });
        },
        /**
         * 删除
         * @param item 要删除的数据
         * **/
        ActionDel(item){
            if( item.id ){
                this.loading = true;
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                    this.$del('sys-menu/'+item.id).then(res=>{
                        this.loading = false , this.LoadDatas() , this.$success('操作成功');
                    }).catch(err=>{
                        this.loading = false , this.$warning(err);
                    })
                }).catch(()=>{
                    this.loading = false;
                })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
	::v-deep .el-table .cell:nth-child(1) {
		text-align: left;
	}
	
	.page_header {
		margin:10px 10px 0;
		position: absolute;
		z-index: 100;
	}
	
	.icon_list {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		text-align: center;
		overflow: auto;
		height: 640px;
		margin-top: -20px;
		.icon_item {
			margin-top: 30px;
			width: 33.3%;
			cursor: pointer;
			i {
				font-size: 40px;
			}
			div {
				font-size: 16px;
				margin-top: 20px;
				width: 120px;
				margin: 10px auto;
				height: 20px;
			}
		}
	}
</style>